import { render, staticRenderFns } from "./OperaGoodsWindow.vue?vue&type=template&id=68c52977&"
import script from "./OperaGoodsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaGoodsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports